module.exports = __webpack_public_path__ + "img/tyres1.cee5089e.png";